module.exports = __webpack_public_path__ + "img/2.67539c05.png";